module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/inspiration-cancel.52d75365.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/inspiration-cancel.png
// module id = 3740
// module chunks = 11